import {ModalContext} from '#/contexts/modal-provider';
import {useUserProfilePrivate} from '#/hooks/query/use-user-profile';
import {useContext} from 'react';

export const useAddFundsAction = (initialAmount?: number) => {
  const {open} = useContext(ModalContext);
  const {data: userProfilePrivate} = useUserProfilePrivate({enabled: false});

  if (!!userProfilePrivate?.requestedFundingAmount) {
    return () => {
      open({
        name: 'CountryNotSupportedModal',
        props: {},
      });
    };
  }

  if (!userProfilePrivate?.firstName || !userProfilePrivate?.lastName || !userProfilePrivate?.email) {
    return () => {
      open({
        name: 'CompleteUserProfileModal',
        props: {},
      });
    };
  }

  return () => {
    open({
      name: 'AddFundsModal',
      props: {
        initialAmount,
      },
    });
  };
};
